import React from 'react';
import { _cs, isDefined } from '@togglecorp/fujs';
import { IoRadioButtonOn, IoRadioButtonOff } from '../../../node_modules/react-icons/io5/index.esm.js';
import { genericMemo } from '../../../utils/index.js';
import InputElementFragments from '../../InputElementFragments/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function Radio(props) {
  const {
    name,
    label,
    className,
    value,
    inputName,
    onClick,
    disabled,
    readOnly,
    spacing = 'comfortable'
  } = props;
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(name);
    }
  }, [name, onClick]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for
    React.createElement("label", {
      className: _cs(styles.radio, value && styles.active, className, disabled && styles.disabled, readOnly && styles.readOnly, spacingToStyleMap[spacing])
    }, /*#__PURE__*/React.createElement(InputElementFragments, {
      icons: value ? /*#__PURE__*/React.createElement(IoRadioButtonOn, {
        className: styles.icon
      }) : /*#__PURE__*/React.createElement(IoRadioButtonOff, {
        className: styles.icon
      })
    }, label), /*#__PURE__*/React.createElement("input", {
      className: styles.input,
      type: "radio",
      name: isDefined(inputName) ? String(inputName) : undefined,
      checked: value,
      onClick: handleClick,
      disabled: disabled
    }))
  );
}

var Radio$1 = genericMemo(Radio);

export { Radio$1 as default };
//# sourceMappingURL=index.js.map
